/* @flow */
import { em } from 'polished';
import { baseFontSize } from '@braindate/ui/lib/token/typography';
import { listReset } from 'src/shared/app/base/style/token/helper';

export default {
  root: {
    ...listReset,
    display: 'flex',
    flexWrap: 'wrap',
  },
  item: {
    marginRight: em(10, baseFontSize),
    marginBottom: em(10, baseFontSize),
    '& :last-child': {
      marginRight: '0',
    },
  },
};
